import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20wide%20shot%20of%20a%20luxurious%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20accents%2C%20soft%20warm%20spotlight%20illuminating%20the%20stage%2C%20classic%20cinema%20architecture%2C%20empty%20theater%20with%20plush%20seats%2C%20atmospheric%20and%20elegant%20mood&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="窝窝影院 - 高清播放在线不缓冲"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-[900px] mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-50 mb-4 leading-tight animate-fade-in">
          窝窝影院
        </h1>
        <p className="text-lg md:text-xl text-foreground-200 mb-3 font-heading animate-fade-in animate-delay-100">
          高清播放 · 在线不缓冲 · 超清画质 · 无广告
        </p>
        <p className="text-sm md:text-base text-foreground-400 mb-8 max-w-[600px] mx-auto leading-relaxed animate-fade-in animate-delay-200">
          海量高清电影电视剧免费在线观看，每日更新不卡顿，流畅观看超清画质无广告，让您享受极致观影体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in animate-delay-300">
          <Link
            to="/category/all"
            className="bg-primary-500 text-background-950 font-medium px-8 py-3 rounded-full hover:bg-primary-400 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
              <i className="ri-play-circle-line"></i>
            </div>
            立即观影
          </Link>
          <Link
            to="/category/all?sort=hot"
            className="border border-foreground-300/30 text-foreground-200 px-8 py-3 rounded-full hover:bg-foreground-50/10 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
              <i className="ri-fire-line"></i>
            </div>
            热门排行
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 animate-fade-in animate-delay-400">
          <div className="text-center">
            <p className="text-primary-400 font-heading text-2xl md:text-3xl">10000+</p>
            <p className="text-foreground-500 text-xs mt-1">高清影片</p>
          </div>
          <div className="w-px h-10 bg-foreground-500/20"></div>
          <div className="text-center">
            <p className="text-accent-400 font-heading text-2xl md:text-3xl">每日更新</p>
            <p className="text-foreground-500 text-xs mt-1">新鲜内容</p>
          </div>
          <div className="w-px h-10 bg-foreground-500/20"></div>
          <div className="text-center">
            <p className="text-primary-400 font-heading text-2xl md:text-3xl">全免费</p>
            <p className="text-foreground-500 text-xs mt-1">无需付费</p>
          </div>
        </div>
      </div>
    </section>
  );
}